import ImageButton from "./ImageButton";

export {
    ImageButton as default,
};
